import { useEffect } from 'react';

/**
 * Hands the whole right-hand pane to the current page while `active`.
 *
 * The shell's scroll pane and the layout's padded wrapper are marked with
 * data attributes; this flips them into a non-scrolling flex column so a page
 * can size itself to the viewport. Reverted on unmount and whenever the page
 * stops asking for it, so every other screen keeps the normal shell.
 */
export function useFullBleedPane(active: boolean) {
  useEffect(() => {
    const targets = Array.from(
      document.querySelectorAll<HTMLElement>('[data-app-scroll], [data-page-pad]'),
    );
    if (!targets.length) return;
    for (const el of targets) el.setAttribute('data-fullbleed', active ? 'true' : 'false');
    return () => {
      for (const el of targets) el.setAttribute('data-fullbleed', 'false');
    };
  }, [active]);
}

export default useFullBleedPane;
